import React from 'react';
import Select from '@/components/ui/Select';
import FormItem from '@/components/ui/FormItem';
import { useCompany } from '@/components/views/Resolution886/components/Form/_hooks/useCompany';
import type { FormItemProps } from '@/components/views/Resolution886/types';

interface CompanyFormItemProps extends FormItemProps {
	fieldName?: string | string[];
}

export function CompanyFormItem({
	required = true,
	allowClear = false,
	labelCol,
	disabled = false,
	fieldName
}: Readonly<CompanyFormItemProps>): JSX.Element {
	const { isLoading, isFetching, items, companyId, handleOnChange, handleOnClear } = useCompany({ fieldName });

	return (
		<FormItem
			name={fieldName}
			required={required}
			labelCol={labelCol}
			label="Industrial site"
			requiredMessage="Please select a industrial site"
		>
			<Select
				options={items}
				value={companyId}
				loading={isFetching}
				allowClear={allowClear}
				onClear={handleOnClear}
				onChange={handleOnChange}
				placeholder="Select a industrial site"
				disabled={isLoading || isFetching || disabled}
			/>
		</FormItem>
	);
}
